export const NAV_LINKS = [
  { to: '/', label: 'Home', labelKey: 'navbar.home' },
  { to: '/cybersecurity', label: 'Cybersecurity', labelKey: 'navbar.cybersecurity' },
  { to: '/ai-engineering', label: 'AI Engineering', labelKey: 'navbar.aiEngineering' },
  { to: '/full-stack', label: 'Full-Stack', labelKey: 'navbar.fullStack' },
  { to: '/projects', label: 'Projects', labelKey: 'navbar.projects' },
  { to: '/experience', label: 'Experience', labelKey: 'navbar.experience' },
];
